import ENTITY_TYPE from "enums/ENTITY_TYPE";
import VIDEO_TYPE from "enums/VIDEO_TYPE";
import endpoints from "hooks/api/endpoints";
import useApiGet from "hooks/api/useApiGet";
import useProjectEndpoint from "hooks/useProjectEndpoint";
import MultipleItemResponse from "types/MultipleItemResponse";
import NoteDto from "types/NoteDto";
import { FILE_TYPE } from "types/VideoDto";

const NOTES_ENTITY_TYPES = new Set<string>(Object.values(ENTITY_TYPE));

export default function useGetEntityNotes(
  entityType?: ENTITY_TYPE | VIDEO_TYPE | FILE_TYPE,
  entityId?: string,
  { suspendQuery = false }: { suspendQuery?: boolean } = {},
) {
  const endpoint = useProjectEndpoint(
    endpoints.getEntityNotes,
    entityType,
    entityId,
  );
  const shouldFetch =
    !suspendQuery &&
    entityId &&
    entityType &&
    NOTES_ENTITY_TYPES.has(entityType);
  const { result, ...rest } = useApiGet<MultipleItemResponse<NoteDto>>(
    shouldFetch ? endpoint : "",
  );

  return { notes: result?.dataList, ...rest };
}
